import { ActivatedRoute, Router } from '@angular/router';
import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ViewChildren, QueryList, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators, FormControl, Form, FormArray, SelectControlValueAccessor } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { Observable, BehaviorSubject, iif, Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatNumber } from '@angular/common';
// import { PagoService } from 'src/app/services/pago.service';
// import { CertxmlpagoService } from 'src/app/services/certxmlpago.service';
import { timeout, startWith, map } from 'rxjs/operators';
// import { formControlBinding } from '@angular/forms/src/directives/reactive_directives/form_control_directive';
import { RutValidator } from 'ng9-rut';
import { HttpHandler } from '@angular/common/http';
import { PropiedadService } from 'src/app/services/propiedad.service';
// import { Socket } from 'ngx-socket-io';
import { PerfilComponent } from '../perfil/perfil.component';

import * as FormActions from '../../reducers/actions/forms.actions';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { GLOBAL } from 'src/app/services/global';
import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_FACTORY } from '@angular/cdk/overlay/overlay-directives';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';

// import { SocketPagosService } from 'src/app/services/socket-pagos.service';

interface AppState {
  form: Form;
}

declare const swal: any;
@Injectable()
@Component({
  selector: "page-solicitud-vivienda",
  templateUrl: "solicitud-vivienda.component.html",
  styleUrls: ["./solicitud-vivienda.component.css"],
  providers: [UserService, PropiedadService, ClaveUnicaService]
})

export class SolicitudViviendaComponent {
  /* @ViewChild('modalSolicitarCertificado') modal_sol_cert: TemplateRef<any>; */
  @ViewChild('ingresarInfo') ingresarInfo: TemplateRef<any>;
  @ViewChild('ingresarInfoListo') ingresarInfoListo: TemplateRef<any>;
  @ViewChild('modalDirecciones') modalDirecciones: TemplateRef<any>;
  @ViewChild('modalNotFound') modalNotFound: TemplateRef<any>;


  public idsocket = ""
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  info_rut
  displayedColumns: string[] = ['rol', 'direccion', 'actions'];
  dialogConfig
  btnDisabled = true

  continuar = false
  direcciones

  public pago_portal: Subscription;
  public pago_finalizado: Subscription;
  public pago_desconectar: Subscription;
  public pago_nuevonumero: Subscription;


  //calculo valores certificados
  valores_cert
  valores_cert_noformat
  valor_total_cert = 0
  mostrar_total

  //forms
  public rut = new FormControl('');
  public rol = new FormControl('');
  public dir = new FormControl('');
  public num = new FormControl('');
  public correo = new FormControl('');
  public nombre = new FormControl('');
  public telefono = new FormControl('');
  public url_fracaso = new FormControl('');
  public url_exito = new FormControl('')

  //direcciones agregadas
  lista_dir = new BehaviorSubject([])
  dirs = []
  identity
  token

  //banderas
  mostrar_solicitud = false
  primerPaso = false
  segundoPaso = false
  tercerPaso = false
  primerPaso_mod = false
  modificando = false
  rut_encontrado = false
  valores_cert_recibidos = false
  cert_seleccionado = false
  folio
  rutcarro
  lista_cert_seleccionados = []
  filteredOptions
  emailValido = false
  link = GLOBAL.webUrl
  nombreLink = GLOBAL.web

  public tipo_solicitud = null;

  // vista_copia = false

  public validFotocopiayCopia = false;

  arrayItems: {
    nombre: string;
    aup: boolean;
    cip: boolean;
    num: boolean;
  }[];

  certificados = [/* {
        cert: "cdpa",
        nombre_completo: "COPIA DE DOCUMENTOS Y PLANOS APROBADOS",
        value: "valor_cdpa",
        state: false
    }, */
    {
      cert: "ravs",
      nombre_completo: "RESOLUCIÓN PARA ACOGER UNA VIVIENDA AL DFL 2 DE 1959",
      value: "valor_ravs",
      state: false
    },
    {
      cert: "rcavs",
      nombre_completo: "RESOLUCIÓN PARA CALIFICAR Y ACOGER UNA VIVIENDE SOCIAL AL DL 2552 DE 1979",
      value: "valor_rcavs",
      state: false
    }]

  ////pago carro 
  id_carro
  carro_prueba
  infoPago
  bandera
  calles
  public copiaDocsBandera = false
  public seleccion_dire = ""
  public seleccion_num = ""
  public seleccion_rol = ""
  public seleccion_cert = ""
  public seleccion_nameCert = ""
  public seleccion_pos;
  public dialogRef
  tamanos = [
    // 'Carta',
    // 'Oficio',
    // 'Tamaño original',
    // 'DIGITAL'
  ];


  fotocopias = [
    // { name: 'Permiso de Edificación, Obra Menor, etc.', value: 'Permiso de Edificación, Obra Menor, etc.' },
    // { name: 'Certificado de Regularización', value: 'Certificado de Regularización' },
    // { name: 'Recepciones de Edificación', value: 'Recepciones de Edificación' },
    // { name: 'Especificaciones Técnicas', value: 'Especificaciones Técnicas' },
    // { name: 'Certificado de Copropiedad', value: 'Certificado de Copropiedad' },
    // { name: 'Reglamento de Copropiedad', value: 'Reglamento de Copropiedad' },
    // { name: 'Otros: ver observaciones', value: 'Otros: ver observaciones' }
  ];

  planos = [
    // { name: 'Plano de Arquitectura', value: 'Plano de Arquitectura' },
    // { name: 'Ubicación en Loteo / Condominio', value: 'Ubicación en Loteo / Condominio' },
    // { name: 'Plano de Conjunto Habitacional', value: 'Plano de Conjunto Habitacional' },
    // { name: 'Plano de Condominio, Copropiedad Inmobiliaria', value: 'Plano de Condominio, Copropiedad Inmobiliaria' },
    // { name: 'Otros: ver observaciones', value: 'Otros: ver observaciones' }
  ];

  // Data: Array<any> = [
  //   { name: 'Pear', value: 'pear' },
  //   { name: 'Plum', value: 'plum' },
  //   { name: 'Kiwi', value: 'kiwi' },
  //   { name: 'Apple', value: 'apple' },
  //   { name: 'Lime', value: 'lime' }
  // ];


  public comunas;
  public regiones;
  public comunasFinal
  public form;

  public showSpinnerComunas = true;
  public showSpinnerRegiones = true;
  public checkedCopias = [];
  public checkedFotocopias = [];


  public checkedCopias2 = [];
  public checkedFotocopias2 = [];
  comunaSelected: boolean;


  constructor(private dialog: MatDialog, private _prop: PropiedadService, private _formBuilder: FormBuilder,
    private _userService: UserService, private _snackBar: MatSnackBar, private spinner: NgxSpinnerService,
    private _changeDetector: ChangeDetectorRef, private rutValidator: RutValidator, private route: ActivatedRoute, private _router: Router,
    private store: Store<AppState>, private claveUnicaService: ClaveUnicaService) {

    console.log("constructor solicitud vivienda tipo solicitud:", this.tipo_solicitud)

    if (this.route.snapshot.paramMap.get("tipo_solicitud") == "resoluciones") {

      this.tipo_solicitud = "Resoluciones";

    }

    if (this.route.snapshot.paramMap.get("tipo_solicitud") == "copia_documentos") {

      this.mostrar_solicitud = true
      this.tipo_solicitud = "Copia";
    }


    // var vista = localStorage.getItem("vista_vivienda")

    // if (vista == "resoluciones") {
    //   // this.vista_copia = false
    //   this.tipo_solicitud = "Resoluciones";
    // }
    // if (vista == "copia_documentos") {
    //   // this.vista_copia = true
    //   this.mostrar_solicitud = true
    //   this.tipo_solicitud = "Copia";
    // }


    console.log("this.tipo_solicitud", this.tipo_solicitud)

    if (this.tipo_solicitud === null) {
      this.spinner.hide();
      console.log("!tipo_solicitud")
      // alert("no seleccionó tipo de solicitud")
      swal({
        type: 'error',
        title: 'Ha ocurrido un error!',
        text: "debe seleccionar tipo de solicitud",
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',

      }).then(() => {
        this._router.navigate([`/aux/vivienda`]);
      })
    }

    this._prop.getCalles().subscribe(response => {
      this.calles = response.calles
      /*  console.log(this.calles) */
      //console.log("this.calles", this.calles);
      this.bandera = true




      console.log("getInfo_solicitud_vivienda")

      //this.getRegiones();
      this.getValores();






    }, error => {
      this.spinner.hide()
      console.log("error ", error)
    })

    this.rut = new FormControl("", Validators.required)
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  ngOnInit() {


    this.arrayItems = [];

    this.firstFormGroup = this._formBuilder.group({
      rut: ['', [Validators.required, Validators.minLength(8), this.rutValidator]],
      mod_solicitante: this._formBuilder.group({
        nombre: ['', [Validators.required]],
        apellido_p: [''],
        apellido_m: [''],
        calle: ['', [Validators.required]],
        num: ['', [Validators.required]],
        complemento: [''],
        telefono: ['', [Validators.minLength(8), Validators.pattern(/[0-9]*/)]],
        cel: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/[0-9]*/)]],
        region: ['', [Validators.required]],
        //ciudad: [''],
        comuna: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]]
      })
    });
    this.secondFormGroup = this._formBuilder.group({
      rol: this.rol,
      dir: this.dir,
      num: this.num
    });


    this.thirdFormGroup = this._formBuilder.group({
      copia: this._formBuilder.array([]),
      tamano: ['', [Validators.required]],
      fotocopia: this._formBuilder.array([]),
      firma: ['', [Validators.required]],
      observaciones: [''],
    })

    this.thirdFormGroup.markAllAsTouched();


    window.scrollTo(0, 0);
    this.spinner.show()
    var intervall
    intervall = setInterval(() => {
      if (this.bandera) {

        this.filteredOptions = this.secondFormGroup.controls.dir.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );
        clearInterval(intervall)
      }
    }, 5000);



  }

  private _filter(value: string): string[] {

    const filterValue = value ? value.toLowerCase() : value;

    return this.calles.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }


  ngDoCheck() {
    this._changeDetector.detectChanges()

    for (let i = 0; i < this.dirs.length; i++) {
      if (this.dirs[i].cdpa || this.dirs[i].ravs || this.dirs[i].rcavs) {
        this.cert_seleccionado = true
      }
    }

  }

  someFunction(i, item, event) {

    for (let i = 0; i < this.dirs.length; i++) {
      if (this.dirs[i].rol == item.rol || (this.dirs[i].calle == item.calle && this.dirs[i].num == item.num)) {
        if (event.source.value == "cdpa" && event.checked) {
          this.dirs[i].cdpa = true
        } else if (event.source.value == "ravs" && event.checked) {
          this.dirs[i].ravs = true
        } else if (event.source.value == "rcavs" && event.checked) {
          this.dirs[i].rcavs = true
        } else if (event.source.value == "cdpa" && !event.checked) {
          this.dirs[i].cdpa = false
        } else if (event.source.value == "ravs" && !event.checked) {
          this.dirs[i].ravs = false
        } else if (event.source.value == "rcavs" && !event.checked) {
          this.dirs[i].rcavs = false
        }
      }

      if (this.dirs[i].cdpa == true || this.dirs[i].ravs == true || this.dirs[i].rcavs == true) {
        this.cert_seleccionado = true
      } else if (this.dirs[i].cdpa == false && this.dirs[i].ravs == false && this.dirs[i].rcavs == false) {
        this.cert_seleccionado = false
      }
    }

  }

  createItem(): FormGroup {
    return this._formBuilder.group({
      aup: false,
      cip: false,
      num: false
    });
  }

  solicitar_Certificados() {
    this.mostrar_solicitud = true
    console.log("solicitar certificados")
  }

  cerrar_vista() {
    // if (this.vista_copia == true) {
    //   this._router.navigate([`/inicio`]);
    // }

    if (this.tipo_solicitud == "Copia") {
      this._router.navigate([`/inicio`]);
    }


    this.mostrar_solicitud = false;
    this.firstFormGroup.reset();
    this.secondFormGroup.reset();
    this.modificando = false
    this.primerPaso = false;
    this.dirs = []
    this.rut.reset();
  }




  buscar_info_sol() {
    window.scrollTo(0, 0);
    this.spinner.show()
    var rutSinPuntos = this.firstFormGroup.controls.rut.value
    if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "")
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "")
      }
    }

    this.continuar = false
    this._userService.traerInfo_rut(rutSinPuntos).subscribe(
      response => {

        console.log("traerInfo_rut response", response)


        this.rut_encontrado = false


        if (response.success) {
          console.log("traerInfo_rut response.success true")

          this.info_rut = response.data
          console.log("this.getRegionOfComuna(this.info_rut.comuna)", this.getRegionOfComuna(this.info_rut.comuna))
          this.info_rut.region = this.getRegionOfComuna(this.info_rut.comuna);
          this.emailValido = this.info_rut.emailValido
          console.log("this.info_rut", this.info_rut)
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(String(this.info_rut.email).toLowerCase())) {

            this.continuar = true
          }

          this.spinner.hide()
          this.primerPaso = true
          this.rut_encontrado = true
          this._changeDetector.detectChanges()
        } else {
          this.modificando = true
          this.rut_encontrado = false
          this.spinner.hide()
        }


      }, error => {

        this.modificando = true
        this.rut_encontrado = false
        this.spinner.hide()

      }
    )
  }

  mod_inforut() {

    this.firstFormGroup.controls.mod_solicitante.setValue({
      nombre: this.info_rut.nombre ? this.info_rut.nombre : "",
      apellido_p: this.info_rut.apellido_p ? this.info_rut.apellido_p : "",
      apellido_m: this.info_rut.apellido_m ? this.info_rut.apellido_m : "",
      calle: this.info_rut.calle ? this.info_rut.calle : "",
      num: this.info_rut.numero ? this.info_rut.numero : "",
      complemento: this.info_rut.complemento ? this.info_rut.complemento : "",
      telefono: this.info_rut.telefono ? this.info_rut.telefono : "",
      cel: this.info_rut.celular ? this.info_rut.celular : "",
      region: this.info_rut.region ? this.info_rut.region : "",
      //ciudad: this.info_rut.ciudad ? this.info_rut.ciudad : " ",

      comuna: this.info_rut.comuna ? this.info_rut.comuna : "",

      email: this.info_rut.email ? this.info_rut.email : ""
    })
    this.primerPaso_mod = true
    this.primerPaso = false
    this.modificando = true

    this.cambiarComunas(false, this.info_rut.comuna);
    // this.getRegiones();
  }

  guarda_mod() {



    this.spinner.show();
    this._userService.save_info_mod_solicitante(this.info_rut.rut, this.firstFormGroup.controls.mod_solicitante.value).subscribe(
      response => {
        this.spinner.hide();

        /*  console.log(response) */
        this.modificando = false
        swal({
          type: 'success',
          title: 'Guardado!',
          text: response.message,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
          this.buscar_info_sol();

        }, (dismiss) => {
          if (dismiss === 'timer') {
            this.buscar_info_sol();
          }
        });

      }, error => {
        console.log(error)

        swal({
          type: 'error',
          title: 'Ha ocurrido un error!',
          text: error._body,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {

        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });

      }
    )
  }

  registro_sol() {

    var rutSinPuntos = this.firstFormGroup.controls.rut.value
    if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "")
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "")
      }
    }

    var userinfo = {
      rut: rutSinPuntos,
      nombre: this.firstFormGroup.controls.mod_solicitante.value.nombre,
      app: this.firstFormGroup.controls.mod_solicitante.value.apellido_p,
      apm: this.firstFormGroup.controls.mod_solicitante.value.apellido_m,
      dir: this.firstFormGroup.controls.mod_solicitante.value.calle,
      num: this.firstFormGroup.controls.mod_solicitante.value.num,
      dircom: this.firstFormGroup.controls.mod_solicitante.value.complemento,
      telefono: this.firstFormGroup.controls.mod_solicitante.value.telefono,
      celular: this.firstFormGroup.controls.mod_solicitante.value.cel,
      //ciudad: this.firstFormGroup.controls.mod_solicitante.value.ciudad,
      region: this.firstFormGroup.controls.mod_solicitante.value.region,
      comuna: this.firstFormGroup.controls.mod_solicitante.value.comuna,
      email: this.firstFormGroup.controls.mod_solicitante.value.email,
    }

    this._userService.save_solicitante(userinfo).subscribe(response => {
      /*   console.log(response) */
      swal({
        type: 'success',
        title: 'Registrado!',
        text: response.message,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 3500
      }).then(() => {
      }, (dismiss) => {
        if (dismiss === 'timer') {
        }
      });
      this.buscar_info_sol()
      this.modificando = false
    }, error => {
      console.log(error)
      swal({
        type: 'error',
        title: 'Ha ocurrido un error!',
        text: error._body,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 3500
      }).then(() => {
      }, (dismiss) => {
        if (dismiss === 'timer') {
        }
      });
    })
  }

  cancelar_mod() {

    if (this.rut_encontrado) {
      this.modificando = false
      this.primerPaso_mod = false
      this.primerPaso = true
    } else {
      this.modificando = false
      this.rut_encontrado = false
      this.primerPaso = false
      this.primerPaso_mod = false
    }

  }


  buscar_info_propiedad_rol() {
    console.log("buscar_info_propiedad_rol")
    // window.scrollTo(0, 0);
    this.spinner.show()

    this._userService.traerInfo_propiedad_rol(this.secondFormGroup.controls.rol.value).subscribe(
      response => {
        this.spinner.hide();
        console.log("buscar_info_propiedad_rol response", response)
        if (response.success) {


          if (response.direcciones) {


            this.direcciones = response.direcciones;
            this.dialog.open(this.modalDirecciones);

            console.log("response.direcciones", response.direcciones)
          }
          else if (response.direccion) {



            console.log("response.direccion")


            var dir_yaExiste = false

            if (response.status == "error") {
              this.secondFormGroup.controls.dir.setValue("")
              this.secondFormGroup.controls.num.setValue("")
              this.secondFormGroup.controls.rol.setValue("")
              this.spinner.hide()
              swal({
                type: 'warning',
                title: 'Atención!',
                text: response.message,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
              }).then(() => {
              }, (dismiss) => {
                if (dismiss === 'timer') {
                }
              });
            } else { //no error
              if (this.dirs.length <= 2) {

                console.log("this.dirs", this.dirs)
                console.log("response", response)
                for (let i = 0; i < this.dirs.length; i++) {

                  if (this.dirs[i].calle == response.direccion.calle && this.dirs[i].num == response.direccion.num) {//podría tener el mismo nombre de calle y numero pero otro rol 
                    dir_yaExiste = true
                  }
                }


                if (!dir_yaExiste) {
                  this.spinner.hide()
                  this.dirs.push(response.direccion)
                  this.lista_dir.next(this.dirs)
                  this._changeDetector.detectChanges();
                  this.secondFormGroup.controls.dir.setValue("")
                  this.secondFormGroup.controls.num.setValue("")
                  this.secondFormGroup.controls.rol.setValue("")
                  if (this.dirs.length > 0) {
                    this.segundoPaso = true
                  }
                } else {
                  this.spinner.hide()
                  this.secondFormGroup.controls.dir.setValue("")
                  this.secondFormGroup.controls.num.setValue("")
                  this.secondFormGroup.controls.rol.setValue("")
                  console.log("La dirección ingresada ya fue agregada1")
                  swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: "La dirección ingresada ya fue agregada",
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                  }).then(() => {
                  }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                  });
                }

              } else {
                this.spinner.hide()
                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                  duration: 2000,
                });
              }
            }


          } else {
            var rol_yaExiste = false
            if (this.dirs.length <= 2) {

              for (let i = 0; i < this.dirs.length; i++) {
                if (this.dirs[i].rol == response.rol) {
                  rol_yaExiste = true

                }
              }
              if (!rol_yaExiste) {


                console.log("this.dirs.push(response) response", response)/////validar si es direccion o direcciones
                this.dirs.push(response)
                this.lista_dir.next(this.dirs)
                this._changeDetector.detectChanges();
                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                if (this.dirs.length > 0) {
                  this.segundoPaso = true
                }
                this.spinner.hide()
              } else {
                this.spinner.hide()
                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                console.log("El rol ingresado ya fue agregado2")

                swal({
                  type: 'warning',
                  title: 'Atención!',
                  text: 'El rol ingresado ya fue agregado',
                  confirmButtonColor: '#3F51B5',
                  confirmButtonText: 'Aceptar',
                  timer: 3500
                }).then(() => {
                }, (dismiss) => {
                  if (dismiss === 'timer') {
                  }
                });

              }

            } else {
              this.spinner.hide()
              this.secondFormGroup.controls.dir.setValue("")
              this.secondFormGroup.controls.num.setValue("")
              this.secondFormGroup.controls.rol.setValue("")
              this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                duration: 2000,
              });
            }
          }
        } else {
          console.log("response.success", response.success)
          this.openNotFoundModal();
        }




      }, error => {
        this.spinner.hide()
        this.secondFormGroup.controls.dir.setValue("")
        this.secondFormGroup.controls.num.setValue("")
        this.secondFormGroup.controls.rol.setValue("")
        swal({
          type: 'error',
          title: 'Ha ocurrido un error!',
          text: error._body,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }
    )
  }

  savePropiedadMulti(direccion) {

    console.log("savePropiedadMulti direccion ", direccion)
    var rol_yaExiste = false
    console.log("this.dirs.length", this.dirs.length)
    if (this.dirs.length <= 2) {
      for (let i = 0; i < this.dirs.length; i++) {
        if (this.dirs[i].direccion_completa == direccion.direccion_completa) {
          rol_yaExiste = true
          console.log(" ya habia sido ingresada la misma direccion", direccion.direccion_completa)
        }
      }
      if (!rol_yaExiste) {
        console.log("!rol_yaExiste")
        this.dirs.push(direccion)
        console.log("this.dirs", this.dirs)
        this.lista_dir.next(this.dirs)
        this._changeDetector.detectChanges();
        this.secondFormGroup.controls.dir.setValue("")
        this.secondFormGroup.controls.num.setValue("")
        this.secondFormGroup.controls.rol.setValue("")
        if (this.dirs.length > 0) {
          this.segundoPaso = true
        }
      } else {
        this.secondFormGroup.controls.dir.setValue("")
        this.secondFormGroup.controls.num.setValue("")
        this.secondFormGroup.controls.rol.setValue("")

        console.log("El rol ingresado ya fue agregado3")
        swal({
          type: 'warning',
          title: 'Atención!',
          text: 'El rol ingresado ya fue agregado',
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });

      }
    } else {
      this.secondFormGroup.controls.dir.setValue("")
      this.secondFormGroup.controls.num.setValue("")
      this.secondFormGroup.controls.rol.setValue("")
      this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
        duration: 2000,
      });
    }


    this.rol.reset();
    this.dir.reset();
    this.num.reset();
    this.dialog.closeAll();
    this.limpiarDocs();
  }

  buscar_info_propiedad_direccion() {
    console.log("buscar_info_propiedad_direccion")
    var calle = ""
    window.scrollTo(0, 0);
    this.spinner.show()
    calle = this.secondFormGroup.controls.dir.value


    calle.toUpperCase()
    this._userService.traerInfo_propiedad_direccion(calle.toUpperCase(), this.secondFormGroup.controls.num.value).subscribe(
      response => {
        this.spinner.hide();

        if (response.success) {


          if (response.direcciones) {
            console.log("response.direcciones");
            this.direcciones = response.direcciones;
            this.dialog.open(this.modalDirecciones);

            console.log("response.direcciones", response.direcciones)
          }
          else if (response.direccion) {
            console.log("response.direccion");

            console.log("entre en buscar por direccion")
            var dir_yaExiste = false

            if (response.status == "error") {
              console.log("response.status error")
              this.secondFormGroup.controls.dir.setValue("")
              this.secondFormGroup.controls.num.setValue("")
              this.secondFormGroup.controls.rol.setValue("")

              swal({
                type: 'warning',
                title: 'Atención!',
                text: response.message,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
              }).then(() => {
              }, (dismiss) => {
                if (dismiss === 'timer') {
                }
              });
            } else {



              if (this.dirs.length <= 2) {

                console.log("this.dirs.length <= 2")

                for (let i = 0; i < this.dirs.length; i++) {
                  console.log("dirs", this.dirs[i])
                  console.log("response", response)
                  if (this.dirs[i].calle == response.direccion.calle && this.dirs[i].num == response.direccion.num) {
                    dir_yaExiste = true
                  }
                }
                if (!dir_yaExiste) {
                  console.log("response.direccion", response.direccion)
                  this.dirs.push(response.direccion)
                  this.lista_dir.next(this.dirs)
                  this._changeDetector.detectChanges();
                  this.secondFormGroup.controls.dir.setValue("")
                  this.secondFormGroup.controls.num.setValue("")
                  this.secondFormGroup.controls.rol.setValue("")
                  if (this.dirs.length > 0) {
                    this.segundoPaso = true
                  }


                } else {

                  this.secondFormGroup.controls.dir.setValue("")
                  this.secondFormGroup.controls.num.setValue("")
                  this.secondFormGroup.controls.rol.setValue("")

                  console.log("La dirección ingresada ya fue agregada4")

                  swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: "La dirección ingresada ya fue agregada",
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                  }).then(() => {
                  }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                  });
                }

              } else {//mas de 3 direcciones

                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                  duration: 2000,
                });
              }
            }
          }
        } else {
          console.log("response.success", response.success)
          console.log("no se encontró")
          this.openNotFoundModal();

        }

      }, error => {
        console.log("buscar por direcciones error ", error)
        this.spinner.hide();
        this.secondFormGroup.controls.dir.setValue("")
        this.secondFormGroup.controls.num.setValue("")
        this.secondFormGroup.controls.rol.setValue("")
        swal({
          type: 'error',
          title: 'Ha ocurrido un error!',
          text: error._body,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }
    )



  }

  addCertificado(propiedad, cert) {

    if (cert.state == false) {
      cert.state = true
    } else {
      cert.state = false
    }

    for (let i = 0; i < this.dirs.length; i++) {
      if (this.dirs[i].rol == propiedad.rol || (this.dirs[i].calle == propiedad.calle && this.dirs[i].num == propiedad.num)) {
        if (cert.cert == "CDPA" && this.dirs[i].cdpa == false) {
          this.dirs[i].cdpa = true
        } else if (cert.cert == "RAVS" && this.dirs[i].ravs == false) {
          this.dirs[i].ravs = true
        } else if (cert.cert == "RCAVS" && this.dirs[i].rcavs == false) {
          this.dirs[i].rcavs = true
        } else if (cert.cert == "CDPA" && this.dirs[i].cdpa == true) {
          this.dirs[i].cdpa = false
        } else if (cert.cert == "RAVS" && this.dirs[i].ravs == true) {
          this.dirs[i].ravs = false
        } else if (cert.cert == "RCAVS" && this.dirs[i].rcavs == true) {
          this.dirs[i].rcavs = false
        }
      }
    }



  }

  eliminar_direccion(i) {
    console.log("eliminar_direccion()")

    var filter = this.dirs.filter((vale, index, arr) => {
      return index != i
    })
    this.dirs = filter
    this.lista_dir.next(this.dirs)
    this._changeDetector.detectChanges();
    if (this.dirs.length > 0) {
      this.segundoPaso = true
    } else {
      this.segundoPaso = false
    }
  }

  cerrar_dialog() {

    this.dialog.closeAll()
    this.primerPaso = false
    this.segundoPaso = false
    this.tercerPaso = false
    this.info_rut = []
    this.dirs = []
  }

  calcular_total() {
    var valor = 0;
    this.valor_total_cert = 0
    var bandera = false
    for (let i = 0; i < this.dirs.length; i++) {
      if (this.dirs[i].cdpa) {
        bandera = true
        this.valor_total_cert = this.valor_total_cert + parseInt(this.valores_cert_noformat.valor_cdpa);
      }
      if (this.dirs[i].ravs) {
        this.valor_total_cert = this.valor_total_cert + parseInt(this.valores_cert_noformat.valor_ravs);
      }
      if (this.dirs[i].rcavs) {
        this.valor_total_cert = this.valor_total_cert + parseInt(this.valores_cert_noformat.valor_rcavs);
      }


    }
    console.log(this.valores_cert)
    this.validarInfo()
    this.mostrar_total = formatNumber(this.valor_total_cert, 'cl')
  }

  ingresoFm() {
    console.log("IngresoFm()")
    window.scrollTo(0, 0);
    this.spinner.show()



    this._userService.ingresoFmVivienda(this.dirs, this.info_rut, this.mostrar_total).subscribe(body => {
      console.log("body", body)
      if (body.code == 200) {
        this.spinner.hide()
        swal({
          type: 'success',
          title: 'Informacion ingresada',
          text: "Mensaje <p>Sr. Contribuyente, para continuar con el proceso</p> " +
            "<p>sera notificado a su correo " + this.info_rut.email + "</p>",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 0,
          onClose: () => {
            this._router.navigate([`/inicio`]);
          }
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      } else if (body.code == 500) {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Ha ocurrido un problema',
          text: "Ha ocurrido un problema insertando la informacion",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 4000,
          onClose: () => {
            this._router.navigate([`/inicio`]);
          }
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }

    }, error => {
      console.log(error)
      swal({
        type: 'warning',
        title: 'Ha ocurrido un problema!',
        text: error._body,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 4000,
        onClose: () => {
          this._router.navigate([`/inicio`]);
        }
      }).then(() => {
      }, (dismiss) => {
        if (dismiss === 'timer') {
        }
      });
    })

  }



  toLobby() {

    this._router.navigateByUrl('/')

    this.dialog.closeAll();
  }


  private docId() {
    let text = '';
    const possible = '0123456789';

    for (let i = 0; i < 8; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }



  closeTab() {
    window.close();
  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._router.navigate(['/inicio']);
    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  ingresarInfoAdicional() {


    console.log("ingresarInfoAdicional thirdFormGroup", this.thirdFormGroup.value);


    var bandera = false
    for (let index = 0; index < this.dirs.length; index++) {
      const element = this.dirs[index];
      console.log("element.rol", element.rol)
      console.log("this.seleccion_rol", this.seleccion_rol)
      if (element.rol == this.seleccion_rol) {
        console.log("element.rol == this.seleccion_rol")
        console.log("element", element)

        element.copia = this.thirdFormGroup.value.copia ? this.thirdFormGroup.value.copia : ""

        element.tamano = this.thirdFormGroup.value.tamano ? this.thirdFormGroup.value.tamano : ""

        element.fotocopia = this.thirdFormGroup.value.fotocopia ? this.thirdFormGroup.value.fotocopia : ""

        element.firma = this.thirdFormGroup.value.firma ? this.thirdFormGroup.value.firma : ""
        element.observaciones = this.thirdFormGroup.value.observaciones ? this.thirdFormGroup.value.observaciones : ""
      }

      if (element.cdpa) {
        if (element.copia == "" || element.tamano == "" || element.fotocopia == "" || element.firma == "") {
          bandera = true
        }
        if (element.copia != "" && element.tamano != "" && element.fotocopia != "" || element.firma != "") {
          bandera = false
        }
      }


    }
    this.limpiarDocs()

    this.validarInfo()
    console.log("this.dirs[]", this.dirs)
  }

  validarInfo() {
    console.log("Inicio de  validarInfo ***************************")
    var bandera = false
    for (let i = 0; i < this.dirs.length; i++) {
      const element = this.dirs[i];
      if (element.cdpa) {
        console.log("Copia entrar a validar", element)
        if (element.tamano || element.firma) {
          if (element.tamano == "" || element.firma == "") {
            console.log("sin datos", element)

            bandera = true
          }
        } else {
          bandera = true
        }


        /*  if (element.copia != "" && element.tamano != "" && element.fotocopia != "" || element.firma != "") {
             bandera = false
         } */
      }
    }

    if (bandera) {
      this.copiaDocsBandera = false
    } else {
      this.copiaDocsBandera = true
    }
    console.log(this.copiaDocsBandera)

  }



  limpiarDocs() {
    console.log("limpiarDocs()")
    /*   this.thirdFormGroup.controls['copia'].setValue([])
      this.thirdFormGroup.controls['fotocopia'].setValue([]) */

    const checkArray: FormArray = this.thirdFormGroup.get("copia") as FormArray;
    const checkArray2: FormArray = this.thirdFormGroup.get("fotocopia") as FormArray;
    // let i: number = 0;
    // checkArray.controls.forEach((item: FormControl) => {
    //   console.log("copia", item.value, i);
    //   checkArray.removeAt(i);
    //   // this.removeNull(checkArray);
    //   //checkArray.filter(x => x !== null)

    //   i++;
    // });

    // let e: number = 0;
    // checkArray2.controls.forEach((item: FormControl) => {
    //   console.log("fotocopia", item.value, e);
    //   checkArray2.removeAt(e);
    //   this.removeNull(checkArray2);
    //   e++;
    // });

    checkArray.clear();
    checkArray2.clear();
    // checkArray.reset();
    // checkArray2.reset();
    // this.thirdFormGroup.reset();

    // this.thirdFormGroup.controls['copia'].setValue("")
    // this.thirdFormGroup.controls['fotocopia'].setValue("") 

    this.thirdFormGroup.controls['tamano'].setValue("")
    this.thirdFormGroup.controls['firma'].setValue("")
    this.thirdFormGroup.controls['observaciones'].setValue("")
    this.seleccion_dire = ''
    this.seleccion_num = ''
    this.seleccion_rol = ''
    this.seleccion_cert = ''
    this.seleccion_nameCert = ''


    console.log("thirdFormGroup after limpiarDocs", this.thirdFormGroup.value);
  }


  openIngresogiro(rol, position) {


    console.log("openIngresogiro()");
    console.log("position", position)
    this.seleccion_pos = position;

    this.spinner.show();
    this._userService.getInfo_solicitud_vivienda().subscribe(
      response => {

        console.log("getInfo_solicitud_vivienda response", response)
        //se cargan valores dinamicos de fotocopia, planos y tamaños
        this.fotocopias = response.fotocopias;
        this.planos = response.planos;
        this.tamanos = response.tamanos

        this.spinner.hide();

        this.validFotocopiayCopia = false;

        this.seleccion_rol = rol

        console.log("openIngresogiro  this.validFotocopiayCopia", this.validFotocopiayCopia)

        // this.checkedCopias[position] = this.dirs[position].copia;
        // this.checkedFotocopias[position] = this.dirs[position].fotocopia;

        // console.log("checkedCopias",this.checkedCopias)
        // console.log("checkedFotocopias",this.checkedFotocopias)

        for (let index = 0; index < this.dirs.length; index++) {
          const element = this.dirs[index];
          console.log("element ", element)



          // if(index == this.seleccion_pos){

          // }


          if (element.rol == this.seleccion_rol) {

            if (element.copia || element.tamano || element.fotocopia || element.firma || element.observaciones) {

              if (element.tamano == "" || element.firma == "") {
                /*   console.log("ingresarInfo1", element) */
                this.dialogRef = this.dialog.open(this.ingresarInfo, {
                  id: "ingresarInfo",
                  disableClose: true,
                });
              } else {

                console.log("this.thirdFormGroup.value", this.thirdFormGroup.value)


                // this.thirdFormGroup.value.copia = element.copia ? element.copia : ""
                // this.thirdFormGroup.value.tamano = element.tamano ? element.tamano : ""
                // this.thirdFormGroup.value.fotocopia = element.fotocopia ? element.fotocopia : ""
                // this.thirdFormGroup.value.firma = element.firma ? element.firma : ""
                // this.thirdFormGroup.value.observaciones = element.observaciones ? element.observaciones : ""



                this.thirdFormGroup = this._formBuilder.group({
                  copia: this._formBuilder.array(element.copia ? element.copia : ""),
                  tamano: ['', [Validators.required]],
                  fotocopia: this._formBuilder.array(element.fotocopia ? element.fotocopia : ""),
                  firma: ['', [Validators.required]],
                  observaciones: [''],
                })


                this.checkedCopias[position] = element.copia;//puede ser el mismo rol y otra direccion
                this.checkedFotocopias[position] = element.fotocopia;

                console.log("checkedCopias[position]", this.checkedCopias[position])
                console.log("checkedFotocopias[position]", this.checkedCopias[position])
                this._changeDetector.detectChanges();



                const checkArray: FormArray = this.thirdFormGroup.get("copia") as FormArray;
                const checkArray2: FormArray = this.thirdFormGroup.get("fotocopia") as FormArray;


                console.log("checkArray", checkArray)

                checkArray.controls.forEach((item: FormControl) => {
                  console.log("checkArray.controls.forEach item", item)

                  if (this.checkedCopias.includes(item.value)) {
                    console.log("checkedCopias includes item.value ", item.value)
                    checkArray.push(new FormControl(item.value));
                  }

                });

                checkArray2.controls.forEach((itemm: FormControl) => {
                  console.log("checkArray2.controls.forEach item", itemm)

                  if (this.checkedFotocopias.includes(itemm.value)) {
                    console.log("checkedFotocopias includes item.value ", itemm.value)
                    checkArray2.push(new FormControl(itemm.value));
                  }

                });

                // this.thirdFormGroup.controls['copia'].setValue(element.copia ? element.copia : "")
                // this.thirdFormGroup.controls['fotocopia'].setValue(element.fotocopia ? element.fotocopia : "") 

                // element.fotocopia.tipo_documento

                this.thirdFormGroup.controls['tamano'].setValue(element.tamano ? element.tamano : "")
                this.thirdFormGroup.controls['firma'].setValue(element.firma ? element.firma : "")
                this.thirdFormGroup.controls['observaciones'].setValue(element.observaciones ? element.observaciones : "")

                // this.seleccion_dire = ''
                // this.seleccion_num = ''
                // this.seleccion_rol = ''
                // this.seleccion_cert = ''
                // this.seleccion_nameCert = ''




                this.dialogRef = this.dialog.open(this.ingresarInfo, {
                  id: "ingresarInfo",
                  disableClose: true,
                });



                console.log("Editar info")



                // this.dialogRef = this.dialog.open(this.ingresarInfoListo, {
                //   id: "ingresarInfoListo",
                //   disableClose: true,
                // });





              }

            } else {
              /*  console.log("ingresarInfo") */
              this.dialogRef = this.dialog.open(this.ingresarInfo, {
                id: "ingresarInfo",
                disableClose: true,
              });
            }

          }
        }

        this.revisarFotocopiayCopia()






      });







  }

  changeStatus(values, element) {
    // console.log("changeStatus");
    // console.log("values",values);
    // console.log("element",element);

  }



  revisarFotocopiayCopia() {


    //console.log("this.thirdFormGroup.controls.copia.value", this.thirdFormGroup.controls.copia.value)
    //console.log("this.thirdFormGroup.controls.fotocopia.value", this.thirdFormGroup.controls.fotocopia.value)

    if (this.thirdFormGroup.controls.copia.value == "" && this.thirdFormGroup.controls.fotocopia.value == "") {
      this.validFotocopiayCopia = false;
    } else {
      this.validFotocopiayCopia = true;
    }

    //console.log("revisarFotocopiayCopia", this.validFotocopiayCopia)
  }



  onCheckboxChange(e, formName) {

    const checkArray: FormArray = this.thirdFormGroup.get(formName) as FormArray;
    // console.log("checkArray", checkArray)
    // console.log("this.thirdFormGroup.get(formName)", this.thirdFormGroup.get(formName));
    if (e.target.checked) {
      // console.log("if(e.target.checked) e.target.checked", e.target.checked)
      // console.log("if(e.target.checked) e.target.value", e.target.value)


      if (e.target.value == 'OTROS: ver observaciones') {
        // console.log("OTROS: ver observaciones (desactivar required observaciones)")
        this.thirdFormGroup.get('observaciones').setValidators([Validators.required])
        this.thirdFormGroup.get('observaciones').updateValueAndValidity();
      }

      checkArray.push(new FormControl(e.target.value));
    } else {
      // console.log("else")
      // console.log("formName", formName)
      this._changeDetector.detectChanges();
      let anotherArray: FormArray
      if (formName == "copia") {
        anotherArray = this.thirdFormGroup.get("fotocopia") as FormArray;
      } else {
        anotherArray = this.thirdFormGroup.get("copia") as FormArray;
      }



      if (e.target.value == 'OTROS: ver observaciones' && !anotherArray.value.includes("OTROS: ver observaciones")) {


        this.thirdFormGroup.get('observaciones').clearValidators();
        this.thirdFormGroup.get('observaciones').updateValueAndValidity();
      }


      let i: number = 0;
      checkArray.controls.forEach((item: FormControl) => {
        // console.log("item", item)
        if (item.value == e.target.value) {
          // console.log("item.value == e.target value e.target.value", e.target.value)
          // console.log("removeAt(i) i", i)
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }


    this.revisarFotocopiayCopia()
  }

  direccioness() {
    // if (this.vista_copia == true) {
    //   for (let i = 0; i < this.dirs.length; i++) {
    //     this.dirs[i].cdpa = true
    //   }
    // }


    if (this.tipo_solicitud == "Copia") {
      for (let i = 0; i < this.dirs.length; i++) {
        this.dirs[i].cdpa = true
      }
    }
    console.log("direcciones() this.dirs", this.dirs)
  }


  openNotFoundModal() {

    this.dialog.open(this.modalNotFound, { disableClose: true });

  }


  getValores() {
    console.log("getValores()")


    if (this.tipo_solicitud == "Resoluciones") {
      console.log("tipo_solicitud == Resoluciones")
      this._userService.get_valores_cert().subscribe(
        response => {

          this.spinner.hide()
          if (response.success) {

            console.log("get_valores_cert() response", response)
            this.valores_cert = {
              valor_cdpa: formatNumber(Math.round(0.1 * response.valores.utm), 'cl'),
              valor_ravs: formatNumber(Math.round(0.1 * response.valores.utm), 'cl'),
              valor_rcavs: formatNumber(Math.round(response.valores.corvi), 'cl'),
            }
            this.valores_cert_noformat = {
              valor_cdpa: Math.round(0.1 * response.valores.utm),
              valor_ravs: Math.round(0.1 * response.valores.utm),
              valor_rcavs: Math.round(response.valores.corvi),
            }
            this.valores_cert_recibidos = true
            this.dialog.closeAll()


            this.getRegiones();
          } else {
            swal({
              type: 'error',
              title: 'Ha ocurrido un error!',
              text: "No se encuentran valores",
              confirmButtonColor: '#3F51B5',
              confirmButtonText: 'Reintentar',
              timer: 5000
            }).then(() => {
              window.location.reload();
            }, (dismiss) => {
              if (dismiss === 'timer') {
                window.location.reload();
              }
            });
          }
        }, error => {
          this.spinner.hide()
          console.log("error", error)
        }
      )
    }
    else {
      console.log("tipo_solicitud != Resoluciones")
      this.getRegiones();
      this.dialog.closeAll()
      console.log("else  this.spinner.hide()")
      this.spinner.hide()
    }









    // if (this.vista_copia == false) {
    //   this._userService.get_valores_cert().subscribe(
    //     response => {
    //       this.spinner.hide()
    //       if (response.success) {
    //         console.log("get_valores_cert() response", response)
    //         this.valores_cert = {
    //           valor_cdpa: formatNumber(Math.round(0.1 * response.valores.utm), 'cl'),
    //           valor_ravs: formatNumber(Math.round(0.1 * response.valores.utm), 'cl'),
    //           valor_rcavs: formatNumber(Math.round(response.valores.corvi), 'cl'),
    //         }
    //         this.valores_cert_noformat = {
    //           valor_cdpa: Math.round(0.1 * response.valores.utm),
    //           valor_ravs: Math.round(0.1 * response.valores.utm),
    //           valor_rcavs: Math.round(response.valores.corvi),
    //         }
    //         this.valores_cert_recibidos = true
    //         this.dialog.closeAll()
    //       } else {
    //         swal({
    //           type: 'error',
    //           title: 'Ha ocurrido un error!',
    //           text: "No se encuentran valores",
    //           confirmButtonColor: '#3F51B5',
    //           confirmButtonText: 'Reintentar',
    //           timer: 5000
    //         }).then(() => {
    //           window.location.reload();
    //         }, (dismiss) => {
    //           if (dismiss === 'timer') {
    //             window.location.reload();
    //           }
    //         });
    //       }
    //     }, error => {
    //       this.spinner.hide()
    //       console.log("error", error)
    //     }
    //   )
    // } else {
    //   this.dialog.closeAll()
    //   console.log("else  this.spinner.hide()")
    //   this.spinner.hide()
    // }
  }

  getComunas() {
    console.log("getComunas")
    this.showSpinnerComunas = true;this.showSpinnerComunas = true;

    this._userService.getComunas().subscribe(
      response => {
        //console.log('getComunas response', response)
        this.comunas = response
        this.showSpinnerComunas = false;
        console.log("getComunas Ready")

      },
      error => {
        let e = JSON.parse(error._body);
        alert(e.message);
      }
    )
  }



  getRegiones() {
    console.log("getRegiones")
    this.showSpinnerRegiones = true;
    this.regiones = this._userService.getRegiones();
    this.showSpinnerRegiones = false;
    //this.regiones = response

    this.getComunas();


    // .then(
    //   response => {
    //     //console.log('getRegiones response', response)

    //   },
    //   error => {
    //     let e = JSON.parse(error._body);
    //     alert(e.message);
    //   }
    // )
  }




  // cambiarComunas(selection: boolean, comuna) {

  //   console.log("cambiarComunas comuna", comuna)
  //   console.log("cambiarComunas selection", selection)

  //   this.comunasFinal = [];
  //   let nRomanoRegion;
  //   let nRomanoComuna

  //   console.log("this.firstFormGroup", this.firstFormGroup.controls.mod_solicitante)
  //   console.log("this.firstFormGroup.controls", this.firstFormGroup.controls.mod_solicitante.value.region)


  //   if (selection) {//actualizar desde html
  //     this.comunaSelected = false;

  //     this.regiones.data.forEach(elemento => {
  //       if (this.quitarTildes(elemento.fieldData.region) == this.quitarTildes(this.firstFormGroup.controls.mod_solicitante.value.region)) {
  //         nRomanoRegion = elemento.fieldData.REG_Numero.toLowerCase();
  //       }
  //     })

  //     this.comunas.forEach(element => {
  //       nRomanoComuna = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//table comunas

  //       if (nRomanoRegion == nRomanoComuna) {
  //         this.comunasFinal.push(element)
  //       }
  //     })
  //     if (this.comunasFinal.length == 0) { console.log(`campo region en tabla regiones ( ${nRomanoRegion}) no coincide con la region en tabla comunas ( ${nRomanoComuna}) `) }
  //     console.log('this.comunasFinal', this.comunasFinal)


  //   } else {//filtrar desde component.ts

  //     this.comunas.forEach(element => {

  //       // console.log("element", element.fieldData.COM_Nombre)
  //       // nRomanoComuna = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//table comunas

  //       // if (nRomanoRegion == nRomanoComuna) {
  //       //   this.comunasFinal.push(element)
  //       // }


  //       if (comuna == element.fieldData.COM_Nombre) {
  //         // nRomanoRegion = element.fieldData.REG_Numero.toLowerCase();
  //         // console.log("nRomanoRegion",nRomanoRegion)

  //         nRomanoComuna = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//table comunas 
  //         console.log("nRomanoComuna", nRomanoComuna);

  //         this.comunasFinal = [];
  //         this.comunasFinal.push(element)

  //         this.firstFormGroup.controls.mod_solicitante.get('region').setValue(element.fieldData.COM_Region.split("-")[1]);
  //         this.firstFormGroup.controls.mod_solicitante.get('region').updateValueAndValidity();



  //         console.log("this.comunasFinal", this.comunasFinal);
  //         this.comunaSelected = true;
  //       }
  //     })


  //   }


  // }
  cambiarComunas(selection: boolean, comuna) {//comuna es la que había sido guardada y que trae desde fm

    console.log("cambiarComunas")
    // console.log("cambiarComunas selection", selection)

    this.comunasFinal = [];
    let nRomanoRegion;
    let nRomanoComuna

    // console.log("this.firstFormGroup", this.firstFormGroup.controls.mod_solicitante)
    // console.log("this.firstFormGroup.controls", this.firstFormGroup.controls.mod_solicitante.value.region)

    if (selection) {//Actualizar Dropdown list cuando seleccionan una opcion en el html
      this.comunaSelected = false;
      this.regiones.data.forEach(elemento => {
        if (this.quitarTildes(elemento.fieldData.region) == this.quitarTildes(this.firstFormGroup.controls.mod_solicitante.value.region)) {
          nRomanoRegion = elemento.fieldData.REG_Numero.toLowerCase();
        }
      })

      this.comunas.forEach(element => {

        nRomanoComuna = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//table comunas
        
        if (nRomanoRegion == nRomanoComuna) {
          this.comunasFinal.push(element)
          this._changeDetector.detectChanges()
        }
      })
      if (this.comunasFinal.length == 0) { console.log(`campo region en tabla regiones ( ${nRomanoRegion}) no coincide con la region en tabla comunas ( ${nRomanoComuna}) `) }
      console.log('this.comunasFinal', this.comunasFinal)


    } else {////Actualizar comunas cuando modifican un usuario y ya había guardado comunas

      console.log("comuna", comuna)//comuna que había sido seleccionada
      // this.regiones.data.forEach(elemento => {
      //   if (this.quitarTildes(elemento.fieldData.region) == this.quitarTildes(this.firstFormGroup.controls.mod_solicitante.value.region)) {
      //     nRomanoRegion = elemento.fieldData.REG_Numero.toLowerCase();
      //   }
      // })
      console.log("this.comunas", this.comunas)
      // this.comunas.forEach(element => {    
      for (let index = 0; index < this.comunas.length; index++) {
        const element = this.comunas[index];
        // if (nRomanoRegion == nRomanoComuna) {
        //   this.comunasFinal.push(element)
        // }
        if (comuna == element.fieldData.COM_Nombre) {//si coincide el nombre de la comuna con la que se había seleccionado
          nRomanoComuna  /*(n de region)*/ = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//numero romano de la region que pertenece comuna que había sidio seleccionada
          console.log("if (comuna == element.fieldData.COM_Nombre) element.fieldData.COM_Nombre", element.fieldData.COM_Nombre)
          console.log("element.fieldData.COM_Region.split('-')[1]", element.fieldData.COM_Region.split("-")[1])
          this.firstFormGroup.controls.mod_solicitante.get('region').setValue(element.fieldData.COM_Region.split("-")[1]);
          this.firstFormGroup.controls.mod_solicitante.get('region').updateValueAndValidity();
          // let comunaElement = element;
          this.comunaSelected = true;
        }
      }
     //vuelve a recorrer comunas para validar cual agregar respecto a la que había sido seleccionada
      for (let index = 0; index < this.comunas.length; index++) {
        const elemento = this.comunas[index];
        if (nRomanoComuna == this.quitarTildes(elemento.fieldData.COM_Region).split("-")[0]) { //valida si coincide numero de region encontrado con el de cada comuna
          console.log("nRomanoComuna == this.quitarTildes(elemento.fieldData.COM_Region).split('-')[0] elemento", elemento)
          this.comunasFinal.push(elemento)
        }
      }
      this._changeDetector.detectChanges()
      console.log("comuna",comuna)
      // this.firstFormGroup.controls.mod_solicitante.get('comuna').updateValueAndValidity(); 
      this.firstFormGroup.controls.mod_solicitante.get('comuna').setValue(comuna);
      this.firstFormGroup.controls.mod_solicitante.get('comuna').updateValueAndValidity();
      // })
      if (this.comunasFinal.length == 0) { console.log(`campo region en tabla regiones ( ${nRomanoRegion}) no coincide con la region en tabla comunas ( ${nRomanoComuna}) `) }
      console.log('this.comunasFinal', this.comunasFinal);
    }
  }

  seleccionComuna() {
    console.log("seleccionComuna")

    this.comunaSelected = true;
  }
  quitarTildes(palabra: string) {
    palabra = palabra.toLowerCase()
    //console.log('palabra.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u").replace(/ñ/gi,"n");',palabra.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u").replace(/ñ/gi,"n"));
    return palabra.replace(/á/gi, "a").replace(/é/gi, "e").replace(/í/gi, "i").replace(/ó/gi, "o").replace(/ú/gi, "u").replace(/ñ/gi, "n");

  }

  getRegionOfComuna(comuna: string) {
    let regionOfComuna


    if (this.comunas && this.comunas.length > 0) {
      this.comunas.forEach(element => {
        if (comuna == element.fieldData.COM_Nombre) {
          regionOfComuna = element.fieldData.COM_Region;
          console.log("regionOfComuna", regionOfComuna)
          return regionOfComuna
        }
      })
    } else {

    }

  }

  cleanData() {

  }


}